"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isArray = _interopRequireDefault(require("lodash/isArray"));
/**
 * This function translates the answer to array even if it is a single value
 * Reason: Backend model is configured such that it will always consider multiple choice question as array
 * Though this is used for only multi select , adding the isSelectType so that we can extend the same function for other cases
 */

function formatAnswerBasedOnType(answer, isSelectType) {
  if (isSelectType && !(0, _isArray["default"])(answer)) {
    return [answer];
  }
  return answer;
}
var _default = exports["default"] = formatAnswerBasedOnType;
//# sourceMappingURL=formatAnswerBasedOnType.js.map